import React from 'react';
import PropTypes from 'prop-types';

import { humanizeNumber } from '../../../utils/format';
import { formatForChart } from '../Util/label';

import PieChart from './PieChart/PieChart';
import SignedBarChart from './SignedBarChart/SignedBarChart';
import TwoValueBar from './TwoValueBar/TwoValueBar';
import SingleValueBar from './SingleValueBar/SingleValueBar';

import MaleFemaleIcon from './images/icon-male-female.png';
import HouseIcon from './images/icon-house.png';
import FamilyIcon from './images/icon-family.png';
import CarIcon from './images/icon-car.png';
import MigrationIcon from './images/icon-migration.png';
import { ESRI_YEAR_DEFAULTS } from '../../../constants';

const PopulationCharts = ({
  colors,
  overview: {
    housing,
    labor,
    population,
    populationByAge,
    futurePopulationByAge,
    malePopulationByAge,
    femalePopulationByAge,
  },
}) => {
  const populationByAgeFormatted = formatForChart(populationByAge);
  const futurePopulationByAgeFormatted = formatForChart(futurePopulationByAge);
  const malePopulationByAgeFormatted = formatForChart(malePopulationByAge, 'short');
  const femalePopulationByAgeFormatted = formatForChart(femalePopulationByAge, 'short');

  return (
    <section>
      <h2 className="section-group-title">
        <span>Population</span>
      </h2>

      <div>
        <PieChart
          sectionTitle={`Population By Age ${ESRI_YEAR_DEFAULTS.currentYear}`}
          data={populationByAgeFormatted}
          colors={colors}
        />

        <PieChart
          sectionTitle={`Population By Age ${ESRI_YEAR_DEFAULTS.projectedYear}`}
          data={futurePopulationByAgeFormatted}
          colors={colors}
        />
      </div>

      <div>
        <SignedBarChart
          sectionTitle={`Age & Gender ${ESRI_YEAR_DEFAULTS.currentYear}`}
          data={[femalePopulationByAgeFormatted, malePopulationByAgeFormatted]}
          colors={colors}
        />

        <TwoValueBar
          sectionTitle={`Median Age ${ESRI_YEAR_DEFAULTS.currentYear}`}
          colors={colors}
          label1="Male"
          label2="Female"
          value1={Math.round(population.maleMedianAge)}
          value2={Math.round(population.femaleMedianAge)}
          image={MaleFemaleIcon}
        />
      </div>

      <div>
        <TwoValueBar
          sectionTitle="Households"
          colors={colors}
          label1={ESRI_YEAR_DEFAULTS.currentYear}
          label2={ESRI_YEAR_DEFAULTS.projectedYear}
          value1={humanizeNumber(housing.totalHouseholdsCurrent)}
          value2={humanizeNumber(housing.totalHouseholdsProjection)}
          image={HouseIcon}
        />

        <TwoValueBar
          sectionTitle="Total Families"
          colors={colors}
          label1={ESRI_YEAR_DEFAULTS.currentYear}
          label2={ESRI_YEAR_DEFAULTS.projectedYear}
          value1={humanizeNumber(housing.familiesCurrent)}
          value2={humanizeNumber(housing.familiesProjection)}
          image={FamilyIcon}
        />
      </div>

      <div>
        <SingleValueBar
          sectionTitle="Average Daily Commute"
          colors={colors}
          value={`${Math.round(labor.averageCommute)} Minutes`}
          image={CarIcon}
        />

        <TwoValueBar
          sectionTitle="Net Migration"
          colors={colors}
          label1={ESRI_YEAR_DEFAULTS.currentYear}
          label2={ESRI_YEAR_DEFAULTS.projectedYear}
          value1={humanizeNumber(
            Math.round(
              population.populationCurrent * (population.netMigrationCurrent / 100)),
            )
          }
          value2={humanizeNumber(
            Math.round(
              population.populationProjection * (population.netMigrationProjection / 100)),
            )
          }
          image={MigrationIcon}
        />
      </div>
    </section>
  );
};

PopulationCharts.propTypes = {
  colors: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string]))
  .isRequired,
  overview: PropTypes.object.isRequired,
};

export default PopulationCharts;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaOverview/PopulationCharts.js